import { render, staticRenderFns } from "./fleet.vue?vue&type=template&id=4af36afd&scoped=true&"
var script = {}
import style0 from "./fleet.vue?vue&type=style&index=0&id=4af36afd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af36afd",
  null
  
)

export default component.exports